module.exports = __webpack_public_path__ + "static/media/fish.f93a2c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fish.png
// module id = 12
// module chunks = 0